import axios from 'axios';

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Accept': 'application/json' }
});

// Redireciona para /login em 401 (exceto durante o proprio login)
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const url: string = error?.config?.url || '';
    if (status === 401 && !url.includes('/auth/login') && !url.includes('/auth/me')) {
      if (location.pathname !== '/login') {
        location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(err: unknown, fallback = 'Erro ao processar requisicao'): string {
  const e = err as { response?: { data?: { error?: string; detail?: string; cStat?: string; xMotivo?: string } } };
  const data = e?.response?.data;
  // Resposta de transmissão rejeitada vem com cStat+xMotivo (SEFAZ falou, não é erro nosso).
  if (data?.xMotivo) {
    const cstat = data.cStat ? `cStat ${data.cStat}: ` : '';
    return `${cstat}${data.xMotivo}`;
  }
  if (data?.detail) return data.detail;
  if (data?.error) return data.error.replace(/_/g, ' ');
  return fallback;
}
